import { render, staticRenderFns } from "./RecoverPasswordConfirm.vue?vue&type=template&id=6272f487"
import script from "./RecoverPasswordConfirm.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordConfirm.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordConfirm.vue?vue&type=style&index=0&id=6272f487&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports